module.exports = __webpack_public_path__ + "static/media/DT3.7ccdee16.jpg";